import React from 'react'
import { Redirect } from 'react-router-dom';

const App = () => {
  return <Redirect to='/admin' />
}

export default App;
